import { Star } from "@mui/icons-material";
import styles from "./Testimonials.module.css";
function Testimonials() {
  return (
    <section className={styles.section} id="testimonials">
      <p className={styles.smallP}>Testimonials</p>
      <h3>
        <strong>What People Say About Me </strong>
      </h3>
      <div className={styles.testimonialsContainer}>
        <div className={styles.testimonials}>
          <ul>
            <li>
              <Star />
            </li>
            <li>
              <Star />
            </li>
            <li>
              <Star />
            </li>
            <li>
              <Star />
            </li>
            <li>
              <Star />
            </li>
          </ul>
          <p className={styles.testimonialsInitialP}>
            <em>
              <span>&quot;</span>
              Abiodun's solutions have truly impressed me. His innovative
              approach to solving complex challenges has significantly impacted
              our projects. His commitment to excellence shines through in every
              endeavor.
              <span>&quot;</span>
            </em>
          </p>
          <p>
            <span>&bull;</span>Naziru Mikail Abubakar<span>&bull;</span>
          </p>
          <p className={styles.position}>Editor-In-Chief | Daily Trust</p>
        </div>
        <div className={styles.testimonials}>
          <ul>
            <li>
              <Star />
            </li>
            <li>
              <Star />
            </li>
            <li>
              <Star />
            </li>
            <li>
              <Star />
            </li>
            <li>
              <Star />
            </li>
          </ul>
          <p className={styles.testimonialsInitialP}>
            <em>
              <span>&quot;</span>
              Abiodun's expertise has been instrumental in driving our success.
              His dedication to understanding our needs and translating them
              into actionable solutions is unparalleled. His contributions have
              been invaluable.
              <span>&quot;</span>
            </em>
          </p>
          <p>
            <span>&bull;</span>Pst (Mrs.) Christy Mbonu <span>&bull;</span>
          </p>
          <p className={styles.position}>CEO | Kanulim Academy</p>
        </div>
        <div className={styles.testimonials}>
          <ul>
            <li>
              <Star />
            </li>
            <li>
              <Star />
            </li>
            <li>
              <Star />
            </li>
            <li>
              <Star />
            </li>
            <li>
              <Star />
            </li>
          </ul>
          <p className={styles.testimonialsInitialP}>
            <em>
              <span>&quot;</span>
              Working with Abiodun has been a game-changer. His ability to think
              outside the box and deliver exceptional results is commendable. He
              has been a key player in elevating our business to new heights.
              <span>&quot;</span>
            </em>
          </p>
          <p>
            <span>&bull;</span>Dr. Olasimbo Davidson<span>&bull;</span>
          </p>
          <p className={styles.position}>CEO | Gold Citii</p>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
